import { render, staticRenderFns } from "./health.vue?vue&type=template&id=7d4a71bf&"
import script from "./health.vue?vue&type=script&lang=js&"
export * from "./health.vue?vue&type=script&lang=js&"
import style0 from "./health.vue?vue&type=style&index=0&id=7d4a71bf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports